import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, createVNode, withModifiers, unref } from "vue";
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import SalesButtonFace from "./index12.js";
const _hoisted_1 = ["aria-label"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SalesButtonTile",
  props: {
    buttonConfig: { default: void 0 },
    configurable: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    badge: { default: null },
    disabled: { type: Boolean, default: false },
    categoryTone: { default: null },
    showEdit: { type: Boolean, default: false }
  },
  emits: ["click", "edit"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const config = computed(() => props.buttonConfig);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["sales-button", { draggable: __props.configurable }])
      }, [
        createElementVNode("div", {
          class: "face-wrap",
          onClick: _cache[0] || (_cache[0] = ($event) => !__props.disabled && emit("click", config.value))
        }, [
          createVNode(SalesButtonFace, {
            config: config.value ?? {},
            selected: __props.selected,
            disabled: __props.disabled,
            badge: Number(__props.badge) || 0,
            "category-tone": __props.categoryTone
          }, null, 8, ["config", "selected", "disabled", "badge", "category-tone"])
        ]),
        __props.showEdit && !__props.disabled ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          class: "edit-chip",
          "aria-label": unref(t)("general.edit"),
          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => emit("edit", config.value), ["stop"]))
        }, [
          createVNode(unref(Icon), {
            icon: "lucide:pen",
            class: "size-4"
          })
        ], 8, _hoisted_1)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=index14.js.map
